<template>
    <header class="rn-header haeder-default header--sticky">
        <div class="container">
            <div class="header-inner">
                <div class="header-left">
                    <logo/>
                    <div class="mainmenu-wrapper">
                        <nav class="mainmenu-nav d-none d-xl-block">
                            <Nav/>
                        </nav>
                    </div>
                </div>
                <div class="header-right">
                    <div class="setting-option rn-icon-list d-block d-lg-none">
                        <div class="icon-box search-mobile-icon">
                            <button @click.prevent="
                                AppFunctions.toggleClass('.large-mobile-blog-search', 'active'),
                                isMobileSearchActive = !isMobileSearchActive
                            ">
                                <i :class="isMobileSearchActive ? 'feather-x' : 'feather-search'"/>
                            </button>
                        </div>
                    </div>
                    <div class="setting-option mobile-menu-bar d-block d-xl-none">
                        <div class="hamberger">
                            <button class="hamberger-button"
                                    @click="AppFunctions.addClass('.popup-mobile-menu', 'active')">
                                <i class="feather-menu"/>
                            </button>
                        </div>
                    </div>
                    <div class="my_switcher setting-option">
                        <ul>
                            <li>
                                <a href="#"
                                   data-theme="light"
                                   class="setColor light"
                                   @click.prevent="AppFunctions.addClass('body', 'active-light-mode'), AppFunctions.removeClass('body', 'active-dark-mode')">
                                    <img class="sun-image" :src="require(`@/assets/images/icons/sun-01.svg`)"
                                         alt="Sun images">
                                </a>
                            </li>
                            <li>
                                <a href="#"
                                   data-theme="dark"
                                   class="setColor dark"
                                   @click.prevent="AppFunctions.addClass('body', 'active-dark-mode'), AppFunctions.removeClass('body', 'active-light-mode')">
                                    <img class="Victor Image" :src="require(`@/assets/images/icons/vector.svg`)"
                                         alt="Vector Images">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import Nav from './Nav';
    import AppFunctions from '../../../helpers/AppFunctions';
    import Logo from "@/components/logo/Logo";

    export default {
        name: 'Header',
        components: {Logo, Nav},
        data() {
            return {
                AppFunctions,
                isMobileSearchActive: false
            }
        },
        mounted() {
            const header = document.querySelector('.header--sticky');
            const setStickyHeader = () => {
                const scrollPos = window.scrollY;
                if (scrollPos > 50) {
                    header.classList.add('sticky');
                } else {
                    header.classList.remove('sticky');
                }
            }
            window.addEventListener('scroll', setStickyHeader);
        }
    }
</script>